import { Global } from "@emotion/react";

import {
  DepositModalOveride,
  DrawerMemberVipOverride,
  MemberVipModalOverride,
  SelectMemberVipOverride,
} from "./css";
import { DropDownHeaderOverride } from "./css";
import { reset } from "./reset";
import { variablesCss } from "./variables";

const GlobalStyles = () => {
  return (
    <>
      <Global
        styles={[
          reset,
          variablesCss,
          DepositModalOveride,
          DropDownHeaderOverride,
          MemberVipModalOverride,
          SelectMemberVipOverride,
          DrawerMemberVipOverride,
        ]}
      />
    </>
  );
};

export default GlobalStyles;
